export default "__VITE_ASSET___3igXyQC__"